import { jwtDecode } from 'jwt-decode';
import { DecodedToken, StaffRole } from '../types';

const normalizeRoleString = (value: unknown): string => {
  return String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, '');
};

/**
 * Frontend-only role derivation from `auth_token`.
 * Backend must still enforce permissions; this only controls UI visibility/actions.
 */
export const getStaffRoleFromToken = (): StaffRole | null => {
  try {
    const token = localStorage.getItem('auth_token');
    if (!token) return null;

    const decoded = jwtDecode<DecodedToken>(token);
    const raw = decoded?.data?.userType ?? decoded?.data?.userTable ?? '';
    const role = normalizeRoleString(raw);

    // More specific staff types before generic "manager" / "ordermanager" (e.g. deliveryOrderManager
    // contains "ordermanager" but must be delivery staff, not order manager).
    if (role.includes('kitchenstaff')) return 'kitchenStaff';
    if (role.includes('servicestaff')) return 'serviceStaff';
    if (
      role.includes('deliverystaff') ||
      role === 'delivery' ||
      role.includes('deliveryboy') ||
      (role.includes('delivery') && role.includes('manager'))
    ) {
      return 'deliveryStaff';
    }
    if (role.includes('counterstaff')) return 'counterStaff';

    if (role.includes('shopowner')) return 'shopOwner';
    if (role.includes('ordermanager')) return 'orderManager';
    if (role === 'manager' || role.includes('manager')) return 'manager';

    return null;
  } catch {
    return null;
  }
};

